<template>
  <form @submit.prevent="createUserSubmit">

    <div class="form-control" :class="{invalid: nError}">
      <label for="name">ФИО (с заглавных букв)</label>
      <input type="text" id="name" v-model="name" @blur="nBlur" autocomplete="off">
      <small v-if="nError">{{nError}}</small>
    </div>

    <div class="form-control" :class="{invalid: passError}">
      <label for="password">Пароль</label>
      <input type="text" id="password" v-model="password" @blur="passBlur" autocomplete="off">
      <small v-if="passError">{{passError}}</small>
    </div>

    <div class="form-control" :class="{invalid: pError}">
      <label for="phone">Телефон (Шаблон: 79857694831)</label>
      <input type="text" id="phone" v-model="phone" @blur="pBlur" autocomplete="off">
      <small v-if="pError">{{pError}}</small>
    </div>

    <div class="form-control" :class="{invalid: cError}">
      <label for="contract">Номер договора (Шаблон: D-1234)</label>
      <input type="text" ref="myInput" id="contract" v-model="contract" @blur="cBlur" @focus="setSelectionRange" autocomplete="off">
      <small v-if="cError">{{cError}}</small>
    </div>

    <div class="form-control" :class="{invalid: eError}">
      <label for="email">Email</label>
      <input type="email" id="email" v-model="email" @blur="eBlur" autocomplete="off">
      <small v-if="eError">{{eError}}</small>
    </div>

    <div class="form-control" :class="{invalid: aError}">
      <label for="address">Адрес</label>
      <input type="text" id="address" v-model="address" @blur="aBlur" autocomplete="off">
      <small v-if="aError">{{aError}}</small>
    </div>

    <div class="form-control" :class="{invalid: eqError}">
      <label for="equipment">Оборудование</label>
      <input type="text" id="equipment" v-model="equipment" @blur="eqBlur" autocomplete="off">
      <small v-if="eqError">{{eqError}}</small>
    </div>

    <div class="form-control" :class="{invalid: vError}">
      <label for="validity">Срок действия договора</label>
      <input type="date" id="validity" v-model="validity" @blur="vBlur" autocomplete="off">
      <small v-if="vError">{{vError}}</small>
    </div>

    <div class="form-control">
      <label for="trest">Трест</label>
      <select id="trest" v-model="trest">
        <optgroup label="МОСКВА">
          <option value="МОСКВА-москва">Москва</option>
        </optgroup>
        <optgroup label="ПОДОЛЬСК">
          <option value="ПОДОЛЬСК-подольск">Подольск</option>
          <option value="ПОДОЛЬСК-ступино">Ступино</option>
          <option value="ПОДОЛЬСК-серебряные пруды">Серебряные пруды</option>
          <option value="ПОДОЛЬСК-михнево">Михнево</option>
          <option value="ПОДОЛЬСК-зарайск">Зарайск</option>
          <option value="ПОДОЛЬСК-кашира">Кашира</option>
          <option value="ПОДОЛЬСК-видное">Видное</option>
          <option value="ПОДОЛЬСК-столбовая">Столбовая</option>
          <option value="ПОДОЛЬСК-чехов">Чехов</option>
          <option value="ПОДОЛЬСК-Домодедово">Домодедово</option>
          <option value="ПОДОЛЬСК-серпухов">Серпухов</option>
          <option value="ПОДОЛЬСК-климовск">Климовск</option>
        </optgroup>
        <optgroup label="ОДИНЦОВО">
          <option value="ОДИНЦОВО-одинцово">Одинцово</option>
          <option value="ОДИНЦОВО-апрелевка">Апрелевка</option>
          <option value="ОДИНЦОВО-щербинка">Щербинка</option>
          <option value="ОДИНЦОВО-вороново">Вороново</option>
          <option value="ОДИНЦОВО-троицк">Троицк</option>
          <option value="ОДИНЦОВО-верея">Верея</option>
          <option value="ОДИНЦОВО-наро-фоминск">Наро-Фоминск</option>
          <option value="ОДИНЦОВО-голицино">Голицино</option>
          <option value="ОДИНЦОВО-можайск">Можайск</option>
          <option value="ОДИНЦОВО-руза">Руза</option>
          <option value="ОДИНЦОВО-барвиха">Барвиха</option>
          <option value="ОДИНЦОВО-кубинка">Кубинка</option>
        </optgroup>
        <optgroup label="НОГИНСК">
          <option value="НОГИНСК-ногинск">Ногинск</option>
          <option value="НОГИНСК-балашиха">Балашиха</option>
          <option value="НОГИНСК-фрязино">Фрязино</option>
          <option value="НОГИНСК-лосино-петровский">Лосино-Петровский</option>
          <option value="НОГИНСК-щёлково">Щёлково</option>
          <option value="НОГИНСК-рошаль">Рошаль</option>
          <option value="НОГИНСК-салтыковка">Салтыковка</option>
          <option value="НОГИНСК-шатура">Шатура</option>
          <option value="НОГИНСК-куровское">Куровское</option>
          <option value="НОГИНСК-ликино-дулево">Ликино-Дулево</option>
          <option value="НОГИНСК-орехово-зуево">Орехово-Зуево</option>
          <option value="НОГИНСК-электроугли">Электроугли</option>
          <option value="НОГИНСК-павлово-посад">Павлово-Посад</option>
          <option value="НОГИНСК-электросталь">Электросталь</option>
        </optgroup>
        <optgroup label="МЫТИЩИ">
          <option value="МЫТИЩИ-мытищи">Мытищи</option>
          <option value="МЫТИЩИ-катуар">Катуар</option>
          <option value="МЫТИЩИ-дмитров">Дмитров</option>
          <option value="МЫТИЩИ-дубна">Дубна</option>
          <option value="МЫТИЩИ-талдом">Талдом</option>
          <option value="МЫТИЩИ-братовщина">Братовщина</option>
          <option value="МЫТИЩИ-сергиев-посад">Сергиев-Посад</option>
          <option value="МЫТИЩИ-пушкино">Пушкино</option>
          <option value="МЫТИЩИ-хотьково">Хотьково</option>
          <option value="МЫТИЩИ-королёв">Королёв</option>
        </optgroup>
        <optgroup label="КРАСНОГОРСК">
          <option value="КРАСНОГОРСК-красногорск">Красногорск</option>
          <option value="КРАСНОГОРСК-химки">Химки</option>
          <option value="КРАСНОГОРСК-сходня">Сходня</option>
          <option value="КРАСНОГОРСК-долгопрудный">Долгопрудный</option>
          <option value="КРАСНОГОРСК-солнечногорск">Солнечногорск</option>
          <option value="КРАСНОГОРСК-клин">Клин</option>
          <option value="КРАСНОГОРСК-шаховская">Шаховская</option>
          <option value="КРАСНОГОРСК-лотошино">Лотошино</option>
          <option value="КРАСНОГОРСК-волоколамск">Волоколамск</option>
          <option value="КРАСНОГОРСК-дедовск">Дедовск</option>
          <option value="КРАСНОГОРСК-истра">Истра</option>
          <option value="КРАСНОГОРСК-нахабино">Нахабино</option>
        </optgroup>
        <optgroup label="КОЛОМНА">
          <option value="КОЛОМНА-коломна">Коломна</option>
          <option value="КОЛОМНА-люберцы">Люберцы</option>
          <option value="КОЛОМНА-малаховка">Малаховка</option>
          <option value="КОЛОМНА-озеры">Озеры</option>
          <option value="КОЛОМНА-быково">Быково</option>
          <option value="КОЛОМНА-бронницы">Бронницы</option>
          <option value="КОЛОМНА-электроизолятор">Электроизолятор</option>
          <option value="КОЛОМНА-жуковский">Жуковский</option>
          <option value="КОЛОМНА-раменское">Раменское</option>
          <option value="КОЛОМНА-егорьевск">Егорьевск</option>
          <option value="КОЛОМНА-луховицы">Луховицы</option>
          <option value="КОЛОМНА-воскресенск">Воскресенск</option>
        </optgroup>
      </select>
    </div>

    <div class="form-control">
      <label for="creator">Кто создал пользователя</label>
      <input type="text" id="creator" v-model="creator" disabled="true">
    </div>

    <div class="form-control">
      <label for="creationDate">Когда создан пользователь</label>
      <input type="text" id="creationDate" v-model="creationDate" disabled="true">
    </div>

    <button class="btn primary" :disabled="isSubmitting" @click="create">Создать</button>
  </form>
</template>

<script>  // Тут находится наша форма, которая выскакивает в модальном окне



import {useRouter} from 'vue-router'
import {useStore} from "vuex";
import {useCreateUserForm} from "@/components/use/createUser-form";
import {ref, onMounted} from "vue";

export default {
  emits: ['created'],

  methods: {
    setSelectionRange: function() {
     this.$refs.myInput.setSelectionRange(2,2)
    }
  },

  setup(_, {emit}) {
    const store = useStore()
    const router = useRouter()

    const submit = async values => {
      await store.dispatch('auth/confirmRegistration', values)
      emit('created')
      await router.push('/admin')
      await store.dispatch('request/getAuthUsers')
    }

    return {
      ...useCreateUserForm(submit),
    }
  }

}
</script>

<style scoped>

</style>